const unsupportedToken = {
	block: "unsupported",
	getAttrs: (tok) => tok.attrs,
};

export default unsupportedToken;
